// eslint-disable-next-line import/no-import-module-exports
import React from 'react';

const emit = require('emmy/emit');
const _ = require('./i18n');
const LoadingComponent = require('./generic/loading');
const { AgeRestriction } = require('./common');
const AdvertButton = require('./advert-button');

function EOTDitem({ item, eotd }) {
  return (
    <div className="eotw" data-eotw-item-id={item.id} data-ping-soon-id={eotd.id}>
      {item.first_image
      && (
      <a href={eotd.url} className="eotw-image" style={{ backgroundImage: `url('${item.first_image}')` }}>
        <div className="eotw-day">{eotd.date_label}</div>
        {eotd.advert_info
          ? (
            <div className="advert-button advert-button_position_absolute" style={{ top: 4, left: 4 }}>
              <div className="advert-button-title">Реклама</div>
              {!eotd.advert_info.force_show_adv_mark
                ? (
                  <div
                    className="advert-button-more"
                    data-advertiser_name={eotd.advert_info.title}
                    data-advertiser_inn={eotd.advert_info.inn}
                    data-advertiser_address={eotd.advert_info.address}
                    data-link={eotd.advert_info.url}
                    data-id={eotd.advert_info.id}
                  >
                    <div>...</div>
                  </div>
                )
                : (
                  <div className="advert-button-more">
                    <div>...</div>
                  </div>
                ) }
            </div>
          )
          : ''}

      </a>
      )}
      <div className="eotw-title">
        <a href={eotd.url} className="eotw-title-link">
          {eotd.title}
          {' '}
        </a>
        <AgeRestriction item={item} className="list-age-restriction-big" />
      </div>
    </div>
  );
}

class EOTDfeed extends LoadingComponent {
  constructor(props) {
    super(props);

    this.state = { eotds: [], ...this.state };
    this.dataUrl = '/widgets/eotd/';
    this.requestParams = { location: props.location };
    if (this.props.eotdId) {
      this.requestParams.eotd_id = this.props.eotdId;
    }
    this.AdButton = new AdvertButton();
  }

  onDataLoad(data) {
    emit(this.props.container, 'eotw-loaded', null, true);
    super.onDataLoad(data);
    this.AdButton.update();
  }

  render() {
    if (!this.shouldRender() || !this.state.eotds.length) { return null; }

    return (
      <div>
        <header className="eotw-header">{_('Events of the week')}</header>
        {/* eslint-disable-next-line react/no-array-index-key,react/jsx-props-no-spreading */}
        {this.state.eotds.map((item, idx) => <EOTDitem key={`eotd-item-#${idx}`} {...item} />)}
      </div>
    );
  }
}

module.exports = EOTDfeed;
